import { Contact } from '../../../providers/api/dtos';
import { AIAnnotationContactData } from '../../../providers/api/dtos/documentFile';
import { isEqual } from '../../../utils/object/object';

const normalizeString = (s?: string): string | undefined => s?.toLowerCase().trim();

// Contact.birthday is a full ISO string (e.g. "1980-01-01T00:00:00.000Z"), while AIAnnotationContactData.birthDay is date-only (e.g. "1980-01-01"). Truncating to 10 chars aligns both formats for comparison.
const normalizeDate = (d?: string): string | undefined => d?.substring(0, 10);

const toContactComparableFields = (contact: Contact) => ({
  name: normalizeString(contact.name),
  fiscalCode: normalizeString(contact.fiscalCode),
  birthday: normalizeDate(contact.birthday),
  birthplace: normalizeString(contact.birthplace),
});

const toSuggestionComparableFields = (suggestion: AIAnnotationContactData) => ({
  name: normalizeString(suggestion.name),
  fiscalCode: normalizeString(suggestion.fiscalCode),
  birthday: normalizeDate(suggestion.birthDay),
  birthplace: normalizeString(suggestion.birthPlace),
});

export const areContactsExactMatch = (
  contact: Contact,
  suggestion: AIAnnotationContactData,
): boolean => isEqual(toContactComparableFields(contact), toSuggestionComparableFields(suggestion), { loose: true });

export const areContactsPartialMatch = (
  contact: Contact,
  suggestion: AIAnnotationContactData,
): boolean => !areContactsExactMatch(contact, suggestion)
  && !!contact.fiscalCode && !!suggestion.fiscalCode
  && normalizeString(contact.fiscalCode) === normalizeString(suggestion.fiscalCode);
